'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'gamepad-modern';
var width = 640;
var height = 512;
var aliases = [127918,63676,"gamepad-alt"];
var unicode = 'e5a2';
var svgPathData = 'M591.7 480L440 480l-16-96-208 0-16 96L48.3 480 0 480l5.4-48L42.8 96 160 32l160 0 160 0L597.2 96l37.5 336 5.4 48-48.3 0zm-423-103.9l6.7-40.1 40.7 0 208 0 40.7 0 6.7 40.1 9.3 55.9 105.7 0L552.3 126.2 467.7 80 320 80 172.3 80 87.7 126.2 53.6 432l105.7 0 9.3-55.9zM232 168l0 32 32 0 24 0 0 48-24 0-32 0 0 32 0 24-48 0 0-24 0-32-32 0-24 0 0-48 24 0 32 0 0-32 0-24 48 0 0 24zm168 72a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm32-64a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faGamepadModern = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;